<div class="p-grid content-create-cedi">
  <div class="p-col-6 content-create-cedi_form">
    <div class="ui-g title" style="width: 250px; margin-bottom: 10px">
      <div>
        <h2>Tipo de punto</h2>
      </div>
      <div class="ui-g-12">
        <p-radioButton name="group1" value="cedi" label="CEDI" [(ngModel)]="cediType" ngDefaultControl></p-radioButton>
      </div>
      <div class="ui-g-12">
        <p-radioButton name="group1" value="tienda" label="TIENDA" [(ngModel)]="cediType"></p-radioButton>
      </div>
    </div>

    <div class="p-col-12 form_cedi">
      <div>
        <h3 class="first">Ciudad</h3>
        <p-autoComplete
          *ngIf="cities !== null"
          name="city"
          [(ngModel)]="newCediPoint.city"
          field="name"
          [suggestions]="filtercities"
          [forceSelection]="true"
          (completeMethod)="filteredCitiesChild($event)"
          [size]="29"
          [minLength]="1"
          placeholder="Ingresa el nombre de la ciudad"
          [dropdown]="true"
        >
          <ng-template let-brand pTemplate="item">
            {{ brand.name }}
          </ng-template>
        </p-autoComplete>
      </div>

      <div class="p-col-12 address">
        <h3 class="first">Dirección</h3>
        <input
          pInputText
          id="direccion"
          class="p-inputtext p-component"
          type="text"
          [(ngModel)]="newCediPoint.coordinates.address"
          [disabled]="!newCediPoint.city.geoName"
          (change)="handleAddresMap($event)"
        />
        <div class="search-adress-error" *ngIf="addressError">
          <p>Por favor valide de nuevo la dirección</p>
        </div>
      </div>
      <div class="p-col-12 name" *ngIf="cediType === 'cedi'">
        <h3 class="first">Nombre</h3>
        <input
          pInputText
          id="nombre"
          class="p-inputtext p-component"
          type="text"
          maxlength="20"
          [(ngModel)]="newCediPoint.name"
          [disabled]="!newCediPoint.city.geoName"
        />
      </div>
    </div>
  </div>
  <div class="p-col-6 content-create-cedi_map">
    <!-- <p-gmap [options]="options" [overlays]="overlays" [style]="{ width: '100%', height: '100%' }"></p-gmap> -->
  </div>
  <div class="p-col-12 content-create_buttons_cedi">
    <p-button label="Cancelar" styleClass="cedi-button ui-button-danger" (click)="handleCloseCreateCediPoint()"></p-button>
    <p-button
      label="Guardar Cambios"
      styleClass="cedi-button"
      [disabled]="newCediPoint.coordinates.address.length === 0"
      (click)="createNewPointCedi()"
    ></p-button>
  </div>
</div>
